/* eslint-disable no-useless-escape */
const REGX = {
  TEXT_256: /^(?=.{0,256}$).*/i,
  EMAIL:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NO_SPECIAL_CHARACTERS: /^[_A-z0-9]*((-|\s)*[_A-z0-9])*$/i,
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
};
export default REGX;
